module.exports = {"portalStaticOrigin":"https://portal-static.imds-cdn.com","streamClient":"aperture","logoConfig":{"link":"/"}}